import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { LocationDTO } from "src/app/features/map-features/sections/locations-section/models/LocationDTO";

@Injectable({
  providedIn: "root",
})
export class CitronellaActionsAPIService implements IApiBase {
  configUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  

  createBlokingRequest(identifier: string) {
    if(!environment.production) console.log(`api/CitronellaActions/CreateBlokingRequest/${identifier}`);
    return this.http.post<any>(this.configUrl + `/api/CitronellaActions/CreateBlokingRequest/${identifier}`, {});
  }

  getBlokingState(identifier: string): Observable<any> {
    if(!environment.production) console.log(`api/CitronellaActions/GetBlokingState/${identifier}`);
    return this.http.get<any>(this.configUrl + `/api/CitronellaActions/GetBlokingState/${identifier}`);
  }

  getLocationImages(identifier: string) {
    return this.http.get<any>(this.configUrl + `/api/CitronellaActions/GetLocationImages?identifier=${identifier}`);
  }

  createProspectTicketRequest(location: LocationDTO, userMail: string) {
    return this.http.post<any>(this.configUrl + `/api/CitronellaActions/CreateProspectTicketRequest/${location.identifier}`, {});
  }
}
